import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUntangleComponent } from './simple-icons-untangle.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUntangleComponent ],
    exports:      [ SimpleIconsUntangleComponent ],
    bootstrap:    []
})
export class SimpleIconsUntangleModule {}
